import api from '.';

export async function getProjectPositions() {
  const { data } = await api.get('/project-positions');

  return data;
}
